<template>
  <div class="fleet-detail">
    <div class="address-line">
      <span class="back" @click="$router.go(-1)">&lt; 返回</span>
      <span class="path" @click="$router.go(-1)">车队列表 &gt;</span>
      杭州联润车队详情
    </div>
    <div class="fleet-intro">
      <h3 class="tt">{{fleetInfo.title}}</h3>
      <p class="line name">
        <span class="lb">车队名称</span>
        {{fleetInfo.company}}
      </p>
      <p class="line area">
        <span class="lb">服务区域</span>
        <span v-for="(service_area,index) in fleetInfo.service_area" :key="index">{{index !== 0 ? '、':'' }}{{service_area.name}}</span>
      </p>
      <p class="line contact">
        <span class="lb">联系车队</span>
         {{fleetInfo.name}}   
         {{fleetInfo.mobile}}
      </p>
      <p class="line">
        <span class="lb">服务类型</span>
        {{fleetInfo.scope}}
      </p>
    </div>
    <div class="service-images">
      <h3 class="tt">服务图片</h3>
      <div class="images-box">
        <div class="images" :class="{'load-more': loadMoreConfig.images}">
          <img v-for="(image, index) in fleetInfo.images" :key="index"
            class="image"
            :src="image"
            alt
          >
        </div>
        <a
          href="javascript:void(0)"
          @click="loadmore('images')"
          class="btn-more"
        >{{loadMoreConfig.images ? '收起' : '查看更多'}}</a>
      </div>
    </div>
    <div class="service-detail">
      <h3 class="tt">车队详情</h3>
      <div class="con-box" :class="{'load-more': loadMoreConfig.text}">
       {{fleetInfo.desc}}
      </div>
      <a
        href="javascript:void(0)"
        @click="loadmore('text')"
        class="btn-more"
      >{{loadMoreConfig.text ? '收起' : '查看更多'}}</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    query: {
      type: Object
    }
  },
  data() {
    return {
      fleetInfo: {},
      loadMoreConfig: {
        images: 0, // 服务图片
        text: 0 // 详情内容
      }
    }
  },
  created() {
    this.getDetailInfo()
  },
  methods: {
    // 切换查看更多和收起
    loadmore(prop) {
      this.loadMoreConfig[prop] = !this.loadMoreConfig[prop]
    },
    getDetailInfo() {
      let params = { fleet_id: this.query.id }
      this.$ajax('get', this.$api.fleetInfo, params).then((res) => {
        if (res) {
          this.fleetInfo = res
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.fleet-detail {
  @leftSpace: 36px;
  .address-line {
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    color: #333;
    .back {
      margin-right: 10px;
    }
    .path,
    .back {
      cursor: pointer;
    }
  }
  .btn-more {
    display: inline-block;
    color: #1b8ccd;
    font-size: 14px;
    cursor: pointer;
    margin: 0 0 20px @leftSpace;
  }
  .fleet-intro {
    height: 228px;
    .tt {
      height: 58px;
      line-height: 58px;
      border-bottom: 1px solid #f5f5f5;
      font-size: 22px;
      color: #000;
    }
    .line,
    .tt {
      padding-left: @leftSpace;
    }
    .line {
      margin: 16px 0;
      .lb {
        color: #7e7e7e;
        font-size: 14px;
        margin-right: 20px;
      }
    }
  }
  .fleet-intro,
  .service-images,
  .service-detail {
    background-color: #fff;
    margin-bottom: 20px;
  }
  .service-images {
    .tt {
      &:extend(.fleet-detail .fleet-intro .tt);
    }
    .images {
      margin: 24px 0 24px @leftSpace;
      height: 238px;
      overflow: hidden;
      &.load-more {
        height: auto;
      }
      .image {
        float: left;
        width: 276px;
        height: 212px;
        border: 1px solid #ddd;
        margin-right: 12px;
        margin-bottom: 24px;
      }
    }
  }
  .service-detail {
    .tt {
      &:extend(.fleet-detail .fleet-intro .tt);
    }
    .con-box {
      min-height: 220px;
      height: 220px;
      overflow: hidden;
      padding-left: @leftSpace;
      line-height: 20px;
      margin: 20px 0;
      word-break: break-all;
      &.load-more {
        height: auto;
      }
    }
  }
}
</style>